// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');

    if (!burgerButton) {
        return;
    }

    const toggleMenu = () => {
        const isOpen = document.body.classList.toggle('gh-head-open');
        burgerButton.setAttribute('aria-expanded', String(isOpen));
    };

    burgerButton.addEventListener('click', toggleMenu);
    burgerButton.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleMenu();
        }
    });
}
